import { Button, InlineStack, Link } from '@customerio/pluma-components/react';

type RelationshipsTableActionsProps = {
  selectedCount: number;
  /** Every relationship the object has, which is what "delete all" covers. */
  total: number;
  canDelete: boolean;
  /** Whether the selection covers the whole page, which is what offers "delete all". */
  isPageSelected: boolean;
  onClearSelection: () => void;
  onDeleteSelected: () => void;
  onDeleteAll: () => void;
};

export function RelationshipsTableActions({
  selectedCount,
  total,
  canDelete,
  isPageSelected,
  onClearSelection,
  onDeleteSelected,
  onDeleteAll,
}: RelationshipsTableActionsProps) {
  if (selectedCount === 0) return null;

  return (
    <InlineStack gap="150" alignBlock="center">
      <Link variant="secondary" isUnderlined onClick={onClearSelection}>
        Clear selection
      </Link>
      <Button isDisabled={!canDelete} onClick={onDeleteSelected} data-test-delete-relationships-button>
        Delete
      </Button>
      {isPageSelected && selectedCount > 1 ? (
        <Button isCritical isDisabled={!canDelete} onClick={onDeleteAll} data-test-delete-all-relationships-button>
          Delete all {total} relationships
        </Button>
      ) : null}
    </InlineStack>
  );
}
